module.exports = __webpack_public_path__ + "img/aquatic-staff-7.31457f72.jpg";